import { render, staticRenderFns } from "./CommunitiesMap.vue?vue&type=template&id=582447b2&"
import script from "./CommunitiesMap.vue?vue&type=script&lang=js&"
export * from "./CommunitiesMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports